import type { Opportunity } from '../types/content';

export const opportunities: Opportunity[] = [
  {
    id: 'cfo-fintech',
    title: 'Chief Financial Officer',
    sector: 'Financial Services',
    function: 'Finance',
    location: 'London, UK',
    summary: 'A high-growth, venture-backed payments platform preparing for its next stage of scale and a potential listing.',
  },
  {
    id: 'ceo-medtech',
    title: 'Chief Executive Officer',
    sector: 'Healthcare & Life Sciences',
    function: 'General Management',
    location: 'Boston, US',
    summary: 'A private equity–owned medical device business seeking a commercially minded leader to drive international expansion.',
  },
  {
    id: 'coo-industrial',
    title: 'Chief Operating Officer',
    sector: 'Industrial & Manufacturing',
    function: 'Operations',
    location: 'Frankfurt, DE',
    summary: 'A family-owned engineering group modernizing its manufacturing footprint across five European sites.',
  },
  {
    id: 'cto-retail',
    title: 'Chief Technology Officer',
    sector: 'Consumer & Retail',
    function: 'Technology',
    location: 'Remote (EMEA)',
    summary: 'A leading omnichannel retailer rebuilding its commerce platform and data capability.',
  },
  {
    id: 'ned-energy',
    title: 'Independent Non-Executive Director',
    sector: 'Energy & Infrastructure',
    function: 'Board',
    location: 'Dublin, IE',
    summary: 'A renewable infrastructure developer strengthening its board with audit committee and capital projects experience.',
  },
];
